(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-mega-store"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function init(root){
      if (!root || root.dataset.aehInit === '1') return;
      root.dataset.aehInit = '1';

      // Announcement dismiss (session-persistent)
      var ann = root.querySelector('[data-aeh-announce]');
      var annKey = 'aeh-ann-' + (root.dataset.sectionId || '');
      if (ann) {
        try { if (sessionStorage.getItem(annKey) === '1') ann.remove(); } catch(e){}
        var annClose = root.querySelector('[data-aeh-announce-close]');
        if (annClose) annClose.addEventListener('click', function(){
          ann.remove();
          try { sessionStorage.setItem(annKey, '1'); } catch(e){}
        });
      }

      // Mega menu
      var mega = root.querySelector('[data-aeh-mega]');
      var megaBtn = root.querySelector('[data-aeh-mega-btn]');
      var megaPanel = root.querySelector('[data-aeh-mega-panel]');
      function openMega(){ if(megaPanel){ megaPanel.classList.add('is-open'); megaBtn.classList.add('is-open'); } }
      function closeMega(){ if(megaPanel){ megaPanel.classList.remove('is-open'); megaBtn.classList.remove('is-open'); } }
      if (mega) {
        mega.addEventListener('mouseenter', openMega);
        mega.addEventListener('mouseleave', closeMega);
        megaBtn.addEventListener('click', function(e){
          e.stopPropagation();
          if (megaPanel.classList.contains('is-open')) { closeMega(); } else { openMega(); }
        });
        document.addEventListener('click', function(e){ if (!mega.contains(e.target)) closeMega(); });
        window.addEventListener('scroll', closeMega, { passive: true });
      }

      // Category switching within mega
      root.querySelectorAll('[data-aeh-cat]').forEach(function(btn){
        btn.addEventListener('mouseenter', function(){ select(btn.dataset.aehCat); });
        btn.addEventListener('click', function(){ select(btn.dataset.aehCat); });
      });
      function select(id){
        root.querySelectorAll('[data-aeh-cat]').forEach(function(b){ b.classList.toggle('is-active', b.dataset.aehCat === id); });
        root.querySelectorAll('[data-aeh-panel]').forEach(function(p){
          p.style.display = p.dataset.aehPanel === id ? '' : 'none';
        });
      }

      // Popovers (lazy-load images on first open)
      root.querySelectorAll('[data-aeh-pop]').forEach(function(pop){
        var btn = pop.querySelector('button');
        btn.addEventListener('click', function(e){
          e.stopPropagation();
          root.querySelectorAll('[data-aeh-pop]').forEach(function(p){ if (p !== pop) p.classList.remove('is-open'); });
          pop.classList.toggle('is-open');
          if (pop.classList.contains('is-open')) {
            pop.querySelectorAll('img[data-src]').forEach(function(img){
              img.src = img.dataset.src; img.removeAttribute('data-src');
            });
          }
        });
      });
      document.addEventListener('click', function(e){
        root.querySelectorAll('[data-aeh-pop]').forEach(function(p){ if (!p.contains(e.target)) p.classList.remove('is-open'); });
      });

      // Drawer + search sheet
      function toggle(target, open){
        if (!target) return;
        target.classList.toggle('is-open', open);
        document.body.style.overflow = open ? 'hidden' : '';
      }
      var drawer = root.querySelector('[data-aeh-drawer]');
      var sheet = root.querySelector('[data-aeh-search-sheet]');
      root.querySelectorAll('[data-aeh-open]').forEach(function(b){
        b.addEventListener('click', function(){
          toggle(b.dataset.aehOpen === 'drawer' ? drawer : sheet, true);
        });
      });
      root.querySelectorAll('[data-aeh-close]').forEach(function(b){
        b.addEventListener('click', function(){ toggle(drawer, false); toggle(sheet, false); });
      });
      [drawer, sheet].forEach(function(el){
        if (!el) return;
        el.addEventListener('click', function(e){ if (e.target === el) toggle(el, false); });
      });
    }

    function boot(){
      var nodes = document.querySelectorAll('.aeh');
      if (!nodes.length) return; // section not on this page — skip all work
      nodes.forEach(init);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else { boot(); }
    document.addEventListener('shopify:section:load', function(e){
      var el = e.target && e.target.querySelector ? e.target.querySelector('.aeh') : null;
      if (el) init(el);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
